import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { StatusPill } from "@/components/StatusPill";
import { useNavigate } from "react-router-dom";
import { TrendingUp } from "lucide-react";
import { toast } from "sonner";

const STAGES = ["new", "contacted", "quoted", "negotiation", "won", "lost"];

export default function DealsPage() {
  const nav = useNavigate();
  const [deals, setDeals] = useState([]);
  const [dragging, setDragging] = useState(null);

  const load = async () => {
    const { data } = await api.get("/deals");
    setDeals(data);
  };
  useEffect(() => { load(); }, []);

  const moveStage = async (id, stage) => {
    try { await api.patch(`/deals/${id}`, { stage }); toast.success("Stage updated"); load(); } catch { toast.error("Failed"); }
  };

  const grouped = STAGES.reduce((acc, s) => ({ ...acc, [s]: deals.filter(d => d.stage === s) }), {});

  return (
    <div className="space-y-6" data-testid="deals-page">
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#4A5A50]">CRM</div>
        <h1 className="font-serif text-3xl lg:text-4xl font-medium">Sales Pipeline</h1>
        <p className="text-[#4A5A50] mt-1">Drag deals across stages to update the pipeline.</p>
      </div>

      <div className="grid grid-flow-col auto-cols-[minmax(260px,1fr)] gap-3 overflow-x-auto pb-4">
        {STAGES.map(stage => {
          const list = grouped[stage] || [];
          const total = list.reduce((s, d) => s + (d.estimated_value || 0), 0);
          return (
            <div
              key={stage}
              onDragOver={(e) => e.preventDefault()}
              onDrop={() => { if (dragging && dragging.stage !== stage) moveStage(dragging.id, stage); setDragging(null); }}
              className="bg-[#F1EDDF] rounded-xl p-3"
              data-testid={`kanban-col-${stage}`}
            >
              <div className="flex items-center justify-between mb-2 px-1">
                <StatusPill status={stage}/>
                <div className="text-xs text-[#4A5A50]">{list.length} · ₹{total.toLocaleString('en-IN')}</div>
              </div>
              <div className="space-y-2">
                {list.map(d => (
                  <div
                    key={d.id}
                    draggable
                    onDragStart={() => setDragging(d)}
                    onDragEnd={() => setDragging(null)}
                    onClick={() => d.contact_id && nav(`/contacts/${d.contact_id}`)}
                    className="bg-white rounded-lg border border-[#E4DFCF] p-3 cursor-grab hover:shadow-md"
                    data-testid={`deal-card-${d.id}`}
                  >
                    <div className="font-medium text-sm">{d.title}</div>
                    <div className="text-xs text-[#4A5A50] mt-0.5">{d.contact_name}</div>
                    <div className="mt-2 font-serif text-lg font-medium text-[#C9A24B]">₹{(d.estimated_value||0).toLocaleString('en-IN')}</div>
                    {d.product_category && <div className="text-[10px] uppercase text-[#4A5A50] tracking-widest mt-1">{d.product_category}</div>}
                  </div>
                ))}
                {list.length === 0 && <div className="text-xs text-[#4A5A50] italic px-2 py-4">Drop deals here</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
